import type { ReactNode } from "react";

export default function DataTable({ columns, rows, empty = "Нет записей", keyOf, actions }: {
  columns: { key: string; label: string; render?: (row: any) => ReactNode }[];
  rows: any[];
  empty?: string;
  keyOf?: (row: any) => string;
  actions?: (row: any) => ReactNode;
}) {
  return <div className="data-table"><table className="admin-table">
    <thead><tr>{columns.map((column) => <th scope="col" key={column.key}>{column.label}</th>)}{actions && <th scope="col">Действия</th>}</tr></thead>
    <tbody>{rows.map((row, index) => <tr key={keyOf?.(row) ?? row.id ?? index}>
      {columns.map((column) => <td key={column.key}>{column.render ? column.render(row) : String(row[column.key] ?? "—")}</td>)}
      {actions && <td><div className="row-actions">{actions(row)}</div></td>}
    </tr>)}</tbody>
  </table>{!rows.length && <div className="empty">{empty}</div>}</div>;
}
